import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    height: 90vh;

    display: flex;
    justify-content: center;
    align-items: center;

    form {
        max-width: 700px;
        margin: 0 auto;
        width: 80%;
        z-index: 99;
        background: #FFF;
        padding: 2rem 1rem;
        border-radius: 30px;
        min-height: 300px;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    label {
        text-align: left;
        width: 100%;
        font-size: 0.9rem;
        color: var(--colorButton);
        margin-top: 1rem;
        font-weight: 700;
    }

    .inputDate {
        width: 100%;
        max-height: 3rem;
        margin-bottom: 1rem;
    }
`